import {
    FetchOpportunityCardSettingsResponse,
    FetchOpportunitiesListingPayload,
    FetchOpportunitiesListingResponse,
    OpportunityCard,
} from './opportunityList.types';
import { updatePaginationButtons } from '../pagination/pagination';
import axios from 'axios';
import saveOrRemoveFavourite from '../../../helpers/favourites';
import copyToClipboard from '../../../helpers/copyToClipboard';
import { IsFavourited } from '../../../helpers/isFavourite';
import IsUserLoggedIn from '../../../helpers/isUserLoggedIn';

const opportunitiesListing = (document.querySelector('.opportunity-list') as HTMLDivElement) || null;

if (opportunitiesListing) {
    const grid = opportunitiesListing.querySelector('.opportunity-list__grid') as HTMLDivElement;
    const nextPageButton = opportunitiesListing.querySelector('.pagination__page-next') as HTMLButtonElement;
    const prevPageButton = opportunitiesListing.querySelector('.pagination__page-prev') as HTMLButtonElement;
    const paginationDropdown = opportunitiesListing.querySelector('.pagination__dropdown') as HTMLSelectElement;
    const paginationLast = opportunitiesListing.querySelector('.pagination__page-last') as HTMLSelectElement;
    const paginationFirst = opportunitiesListing.querySelector('.pagination__page-first') as HTMLSelectElement;
    const pagination = opportunitiesListing.querySelector('.pagination') as HTMLDivElement;
    const radios: NodeListOf<HTMLInputElement> = opportunitiesListing.querySelectorAll('.sort-filter__input');
    const opportunitiesListingSearchInput = opportunitiesListing.querySelector('.opportunity-list__search-input') as HTMLInputElement;
    const opportunitiesFilters = opportunitiesListing.querySelector('.opportunity-list__filters') as HTMLDivElement;
    const currentCulture: string = document.documentElement.getAttribute('culture');
    const favouritedIds: number[] = JSON.parse(grid.getAttribute('data-ids'));

    let opportunitiesCards: OpportunityCard[] = [];
    let keyword = '';
    let sortBy = 1;
    let pageNumber = 1;
    let pageSize = +paginationDropdown.value;
    let totalPages = 0;
    let totalCount: number = 0;
    let hasNextPage = false;
    let hasPreviousPage = false;
    let buttonsToShow: number = 3;
    let isLoading = false;
    let clickedNumber = null;

    let opportunityCardSettings: FetchOpportunityCardSettingsResponse = {
        cardButtonText: '',
        availableText: '',
        endText: '',
    };

    const fetchOpportunityCardSettings = async () => {
        try {
            const response = await axios.get<FetchOpportunityCardSettingsResponse>(
                `/api/opportunities/cardsettings?currentCulture=${currentCulture}`,
            );

            opportunityCardSettings = response.data;
        } catch (error) {
            console.error(error);
        }
    };

    const fetchOpportunities = async (page = null) => {
        clickedNumber = page;
        pagination.classList.add('hidden');

        if (clickedNumber) {
            pageNumber = page;
        }

        const payload: FetchOpportunitiesListingPayload = {
            keyword,
            sortBy,
            pageNumber,
            pageSize,
            currentCulture,
        };

        isLoading = true;
        disableInputs();

        try {

            const response = await axios.post<FetchOpportunitiesListingResponse>('/api/opportunities', payload);

            opportunitiesCards = response.data.items;

            if (opportunitiesCards.length > 0) {
                pagination.classList.remove('hidden');
            }

            totalCount = response.data.totalCount;
            totalPages = response.data.totalPages;
            hasNextPage = response.data.hasNextPage;
            hasPreviousPage = response.data.hasPreviousPage;
        } catch (error) {
            console.error(error);
            enableInputs();
        } finally {
            updatePaginationButtons(
                totalPages,
                hasPreviousPage,
                hasNextPage,
                pageNumber,
                pageSize,
                totalCount,
                buttonsToShow,
                opportunitiesCards,
                fetchOpportunities,
            );
            isLoading = false;
            updateCards();
            enableInputs();
        }
    };

    const disableInputs = () => {
        pagination.classList.add('disabled');
        opportunitiesFilters.classList.add('disabled');
    };

    const enableInputs = () => {
        pagination.classList.remove('disabled');
        opportunitiesFilters.classList.remove('disabled');
    };

    const updateCards = () => {
        grid.innerHTML = '';

        opportunitiesCards.forEach((card: OpportunityCard) => {
            const cardElement = document.createElement('a');
            cardElement.className = 'opportunity-list__card fade-in';
            cardElement.setAttribute('href', card.link);

            var _class = '';
            if (IsFavourited(card.id, favouritedIds)) {
                _class = 'active';
            }

            cardElement.innerHTML = `
                <p class='opportunity-list__card-tag'>${
                    card.isAvailable ? opportunityCardSettings.availableText : opportunityCardSettings.endText
                }</p>
				<h3 class='opportunity-list__card-title'>${card.title}</h3>
				<p class='opportunity-list__card-text'>
						${card.description}
				</p>
				<div class='opportunity-list__card-bottom flex flex--justify-between flex--align-center'>
                        <div class="opportunity-list__link flex flex--align-center flex--justify-center">
                            ${opportunityCardSettings.cardButtonText}
                            <img src="/assets/img/img/arrow-top-left-dark.svg" alt="arrow icon"
                                class="opportunity-list__link-icon">
                        </div>
					<div class='opportunity-list__card-buttons flex flex--align-center'>
                        ${
                            IsUserLoggedIn()
                                ? `<button class="button button--favourite-small favouriteButton opportunity-list__button flex flex--justify-center flex--align-center ${_class}" data-type="opportunity" data-id="${card.id}">
                                </button>`
                                : ''
                        }
						<button class="button  button--round-small shareButton opportunity-list__button-share opportunity-list__button  flex flex--justify-center flex--align-center">
								<img src="/assets/img/img/share-icon.svg" alt="share icon" class="button__image">
						</button>
					</div>
				</div>
				`;

            grid.appendChild(cardElement);
        });

        addCardListeners();
    };

    // Listeners
    paginationDropdown.addEventListener('change', () => {
        pageSize = +paginationDropdown.value;
        pageNumber = 1;
        fetchOpportunities();
    });

    nextPageButton.addEventListener('click', () => {
        pageNumber++;

        fetchOpportunities();
    });

    prevPageButton.addEventListener('click', () => {
        pageNumber--;

        fetchOpportunities();
    });

    paginationFirst.addEventListener('click', () => {
        pageNumber = 1;
        fetchOpportunities();
    });

    paginationLast.addEventListener('click', () => {
        pageNumber = totalPages;
        fetchOpportunities();
    });

    let timeout = null;
    opportunitiesListingSearchInput.addEventListener('input', (e) => {
        clearTimeout(timeout);

        timeout = setTimeout(function () {
            keyword = opportunitiesListingSearchInput.value.trim();
            pageNumber = 1;
            fetchOpportunities();
        }, 1000);
    });

    radios.forEach((radio) => {
        // 1 = Latest
        // 2 = A-Z
        // 3 = Z-A

        radio.addEventListener('change', () => {
            const checkedRadio = opportunitiesListing.querySelector('input[name="sort-filter"]:checked') as HTMLInputElement;
            const checkedRadioValue = checkedRadio.value;
            sortBy = +checkedRadioValue;
            fetchOpportunities();
        });
    });


    const initializeEventsList = async () => {
        await fetchOpportunityCardSettings();
        await fetchOpportunities();
    };

    // Call the initialize function
    initializeEventsList();

    const addCardListeners = () => {
        const opportunityListCards: NodeListOf<HTMLAnchorElement> = opportunitiesListing.querySelectorAll('.opportunity-list__card');

        if (opportunityListCards.length > 0) {
            const cardButtons: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.opportunity-list__button');

            opportunityListCards.forEach((card) => {
                card.addEventListener('click', (e) => {
                    const target = e.target as HTMLElement;

                    if (target.classList.contains('button') || target.classList.contains('button__image')) {
                        e.preventDefault();
                    }
                });
            });

            cardButtons.forEach((button) => {
                button.addEventListener('click', (e) => {
                    if (button.classList.contains('favouriteButton')) {
                        let t = button.getAttribute('data-type');
                        var id = Number(button.getAttribute('data-id'));
                        saveOrRemoveFavourite(t, id, button);
                    } else if (button.classList.contains('shareButton')) {
                        copyToClipboard(button);
                    }
                });
            });
        }
    };
}
